import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { defineCustomElements } from '@trv-tds/webcomponents/dist/loader';
import store from './redux/store';
import './assets/styles/global.scss';
import App from './App.js';

// Define TDS custom elements before rendering
defineCustomElements();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
